import { renderSupportAgreement, supportAgreementHtml } from '../components/support-agreement';
import { supportProfileDraftStyles, supportProfileFormHtml } from './support-profile-setup';

function injectStyles(): void {
	if (document.getElementById('sp-draft-styles')) return;
	const style = document.createElement('style');
	style.id = 'sp-draft-styles';
	style.textContent = supportProfileDraftStyles();
	document.head.appendChild(style);
}

function shell(title: string): HTMLElement {
	document.title = title;
	injectStyles();

	// Override dashboard layout for public-link page
	document.body.classList.add('sp-public-body');
	const root = (document.getElementById('app') ?? document.body) as HTMLElement;
	root.classList.add('sp-public-root');
	root.innerHTML = '';

	const hide = (id: string): void => {
		const el = document.getElementById(id);
		if (el) el.style.display = 'none';
	};
	hide('sidebar-scrim');
	hide('modal-overlay');
	hide('toast');

	const page = document.createElement('div');
	page.className = 'sp-page';
	root.appendChild(page);
	return page;
}

export function renderSupportOnboarding(): void {
	const page = shell('Support onboarding - Hub People');
	page.innerHTML = `
    <main class="sp-shell">
      <div class="sp-brand">the hub ecosystems</div>
      <header class="sp-hero">
        <h1>Support onboarding</h1>
        <p>Complete your support profile and review the information before you submit it.</p>
      </header>
      <div class="sp-notice">This is a development-stage Hub People workflow. It does not create a full Hub People account. Your information is used only as needed for support coordination, support records, and invoicing.</div>
      <div class="sp-progress" aria-label="Progress"><span class="sp-active"></span><span class="sp-active"></span></div>
      ${supportProfileFormHtml()}
      ${supportAgreementHtml({ supportedPerson: 'Mitchell', supportPerson: 'Support person from this profile' })}
    </main>
  `;
}

export function renderSupportAgreementDraftOnly(): void {
	const page = shell('Support agreement - Hub People');
	page.innerHTML = `
    <main class="sp-shell">
      <div class="sp-brand">the hub ecosystems</div>
      <header class="sp-hero">
        <h1>Support agreement</h1>
        <p>Review the details and terms for this one-time support booking.</p>
      </header>
      <div class="sp-notice">This is a development-stage Hub People workflow. It does not create a full Hub People account. Your information is used only as needed for support coordination, support records, and invoicing.</div>
      <div id="sp-agreement-mount"></div>
    </main>
  `;
	const mount = page.querySelector<HTMLElement>('#sp-agreement-mount');
	if (mount) {
		renderSupportAgreement(mount, {
			supportedPerson: 'Mitchell',
			supportPerson: 'Support person',
		});
	}
}

export function isSupportOnboardingPath(): boolean {
	return /\/support-onboarding\/[^/]+\/?/.test(window.location.pathname);
}

export function isSupportAgreementDraftPath(): boolean {
	return /\/support-agreement\/draft\/?/.test(window.location.pathname);
}
